// src/utils/calendarDayOffset.js
// Whole calendar days from `now` to `target`, both read as local dates.
//
// Create Event sends an absolute start as { dayOffset, absHour, absMinute }, and
// eventCreationHelpers rebuilds it as "today + dayOffset at absHour:absMinute".
// The old offset was floor((target - now) / 24h), which comes out one day short
// whenever the current time of day is later than the picked time (11-04: at
// 3:00 PM, "Sat Jan 16, 2:00 PM" was sent as Fri Jan 15, 2:00 PM). Counting
// calendar days (UTC of each local Y/M/D, so daylight saving never shifts it)
// makes the rebuilt start equal the picked one.
export function calendarDayOffset(target, now = new Date()) {
  const a = new Date(target);
  const b = new Date(now);
  if (Number.isNaN(a.getTime()) || Number.isNaN(b.getTime())) return 0;
  const dayA = Date.UTC(a.getFullYear(), a.getMonth(), a.getDate());
  const dayB = Date.UTC(b.getFullYear(), b.getMonth(), b.getDate());
  return Math.round((dayA - dayB) / 86400000);
}

export default calendarDayOffset;
